import "./IndexLife.css";
import houseWife from "./Images/house-wife.jpg"
import IconFeather from "./Images/Icon feather-trending-down.png"
import hdfc from "./Images/HDFC_Life_Logo.png";
import TataAia from "./Images/TATA-AIA-Logo.png";
import "./HouseWifeTerm.css";

const HouseWifeTerm = () => {
    return (
        <div className="col-lg-7">
            <h4 className="Index-Plan housewife-main-heading">
                <span className="textcolor">Protecting</span> Housewives: Term Insurance Solutions
            </h4>
            <p className="Index-Plan-Cont">
                Safeguarding the Backbone of Every Home
            </p>
            <div className="Added_PicTaxBenefitBox">
                <div className="row">
                    <div className="col-12">
                        <div className="MRN_imgBox">
                            <div className="HouseWife_Img">
                                <img src={houseWife} alt="HouseWife Insurance" />
                            </div>
                            <div className="TaxBenefits TaxBenefits3">
                                <div className="GetLifeCNT2">
                                    <div className="">
                                        <img
                                            src={IconFeather}
                                            alt="Life Plan"
                                        />
                                    </div>
                                    <p className="housewife_percentoff_content">Pay up to <strong>28% less</strong> on the premiums</p>
                                </div>
                            </div>
                            <div className="brands-housewife">
                                <div className="allianceBox">
                                    <div className="alliances">
                                        {/* <img src={AegonLogo} alt="Aegon Logo" />*/}
                                        <img
                                            src="https://www.smcinsurance.com/insurer%20logo/aegon.jpg"
                                            className=""
                                        />
                                    </div>
                                    <div className="">
                                        <div className="alliances02">
                                            <img src={TataAia} alt="Aegon Logo" />
                                        </div>
                                        <div className="alliances02"><span>+many more</span></div>
                                    </div>
                                    <div className="alliances">
                                        <img className="hdfc-logo" src={hdfc} alt="HDFC Logo" />
                                    </div>
                                </div>
                                {/*<div className="review_box2">
                                                        <a className="review_box" href="/customer-reviews" target="_blank">
                                                            <div className="Google_rate">
                                                                <img src={Google} className="google_img" />
                                                                <img src={Rating} className="rating_img" />
                                                            </div>
                                                            <p>Highly rated insurance website</p>
                                                        </a>
                                                    </div>*/}
                            </div>

                        </div>
                    </div>
                    {/*  <div className="col-md-6">
                                            <div className="Family_lifesec women_life">
                                                <div>
                                                    <img src={WomenLife} className="imgtop m-auto" alt="Life Plan Image" />
                                                </div>
                                                
                                            </div>

                                            <div className="review_box2 review_box2_women">
                                                <a
                                                    className="review_box"
                                                    href="/customer-reviews"
                                                    target="_blank"
                                                >
                                                    <div className="indem-rate">
                                                        <img src={google} className="indem_googl" />
                                                        <img src={rattings} className="indem_star" />
                                                    </div>
                                                    <p>Highly rated insurance website</p>
                                                </a>
                                            </div>

                                        </div>*/}

                    <div className="col-md-6 p-0">
                        <ul className="partners_img partners_img2">
                            <li className="partner_logo partner_logo1">
                                <span>
                                    <img
                                        src="https://www.smcinsurance.com/insurer%20logo/aegon.jpg"
                                        className="aegon_life"
                                    />
                                </span>
                            </li>
                            <li className="partner_logo">
                                <span>
                                    <img src={hdfc} className="hdfc_life" />
                                </span>
                            </li>

                            <li className="partner_logo partner_logo1">
                                <span>
                                    <img src={TataAia} className="tata_aia" />
                                </span>
                            </li>

                            <li className="Add_more">
                                <span>+many more</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default HouseWifeTerm;
